<se-fe-block class="price-variation-container">
  <form [formGroup]="formGroup">
    <div class="field-group">
      <div
        class="field-label"
        id="variationNameLabel">
        <span>Variation Name</span>
        <span seFePopoverTrigger="variationNamePopover">
          <se-fe-icon
            seFeDataName="question_circle"
            seFeDataSize="600"
            seFeDataColor="blue"></se-fe-icon>
        </span>
        <se-fe-popover seFePopoverName="variationNamePopover">
          Product variation name will display on your sales reports
        </se-fe-popover>
      </div>
      <se-fe-form-field-text
        formControlName="pricing_name"
        seFeDataLabel="Variation Name"
        [seFeDataComfy]="false"
        [attr.aria-labelledby]="'variationNameLabel'"
        (change)="trimName()"></se-fe-form-field-text>
      @if (!formGroup.controls.pricing_name.pristine && formGroup.controls.pricing_name.hasError('required')) {
        <div class="error-message">The name is required</div>
      }
      @if (
        !formGroup.controls.pricing_name.pristine &&
        (formGroup.controls.pricing_name.hasError('nameNotUnique') ||
          formGroup.controls.pricing_name.hasError('savedNameNotUnique'))
      ) {
        <div class="error-message">Price variations must have unique names</div>
      }
      <div class="field-help">For example, “Early Bird Price”</div>
    </div>

    <div class="field-group">
      <div
        class="field-label"
        id="variationPriceLabel">
        Variation Price
      </div>
      <se-fe-form-field-text
        formControlName="price_cents"
        seFeDataLabel="Variation Price"
        [seFeDataComfy]="false"
        [attr.aria-labelledby]="'variationPriceLabel'"
        (change)="handlePriceChange()"
        (blur)="formatAmount('price_cents')">
        <se-fe-icon
          seFeFormFieldTextBefore
          seFeDataName="dollar"
          seFeDataSize="500"
          seFeDataColor="black"></se-fe-icon>
      </se-fe-form-field-text>
      @if (!formGroup.controls.price_cents.pristine && formGroup.controls.price_cents.hasError('positiveNumber')) {
        <div class="error-message">Price must be a positive number.</div>
      }
      @if (!formGroup.controls.price_cents.pristine && formGroup.controls.price_cents.hasError('notEqualSibling')) {
        <div class="error-message">Price cannot match other price variations.</div>
      }
      @if (partialAmountDueUpFrontSelected && formGroup.controls.price_cents.hasError('min')) {
        <div class="error-message">Price must be at least $25 when partial amount due upfront is selected.</div>
      }
    </div>

    @if (partialAmountDueUpFrontSelected && priceVariationGreaterThanTwentyFive && !isZeroRateType) {
      <div class="field-group">
        <div
          class="field-label"
          id="upfrontAmountLabel">
          Partial amount due upfront
        </div>
        <se-fe-form-field-text
          formControlName="upfront_amount_cents"
          seFeDataLabel="Partial amount due upfront"
          [seFeDataComfy]="false"
          [attr.aria-labelledby]="'upfrontAmountLabel'"
          (change)="handleUpfrontChange()"
          (blur)="formatAmount('upfront_amount_cents')"
          [seFeDataPlaceholder]="formGroup.controls.upfront_amount_cents.disabled ? 'Price must be valid first' : ''">
          <se-fe-icon
            seFeFormFieldTextBefore
            seFeDataName="dollar"
            seFeDataSize="500"
            [seFeDataColor]="formGroup.controls.upfront_amount_cents.disabled ? 'gray' : 'black'"></se-fe-icon>
        </se-fe-form-field-text>
        @if (
          !formGroup.controls.upfront_amount_cents.pristine && formGroup.controls.upfront_amount_cents.hasError('min')
        ) {
          <div class="error-message">Enter $0.50 or more</div>
        }
        @if (
          !formGroup.controls.upfront_amount_cents.pristine &&
          formGroup.controls.upfront_amount_cents.hasError('required')
        ) {
          <div class="error-message">The upfront amount is required</div>
        }
        @if (
          !formGroup.controls.upfront_amount_cents.pristine &&
          formGroup.controls.upfront_amount_cents.hasError('pattern')
        ) {
          <div class="error-message">Enter a valid amount</div>
        }
        @if (
          !formGroup.controls.upfront_amount_cents.pristine &&
          formGroup.controls.upfront_amount_cents.hasError('maxPercentage')
        ) {
          <div class="error-message">Upfront amount can't be more than {{ maxPartial | currency }}.</div>
        }
        @if (
          !formGroup.controls.upfront_amount_cents.pristine &&
          formGroup.controls.upfront_amount_cents.hasError('positiveNumber')
        ) {
          <div class="error-message">Upfront amount must be a positive number.</div>
        }
      </div>
    }

    <div class="date-range-container">
      <se-fe-datepicker
        seFeDataLabel="Start Date"
        [seFeDataDateRangeIcon]="true"
        formControlName="start_date"
        [seFeDataYearRange]="dateRangeConfig.yearRange"
        [seFeDataMessages]="dateRangeConfig.messages"
        [seFeDataExcludeDates]="getExcludedDates(priceVariation.is_editing, dateType.START)"></se-fe-datepicker>

      <div>
        <se-fe-datepicker
          seFeDataLabel="End Date"
          [seFeDataDateRangeIcon]="true"
          formControlName="end_date"
          [seFeDataYearRange]="dateRangeConfig.yearRange"
          [seFeDataMessages]="dateRangeConfig.messages"
          [seFeDataExcludeDates]="getExcludedDates(priceVariation.is_editing, dateType.END)"></se-fe-datepicker>
        @if (formGroup.controls.end_date.hasError('endDateBeforeStartDate') && formGroup.controls.end_date.touched) {
          <div class="error-message">End date must be after start date</div>
        }
      </div>
    </div>

    @if (formGroup.controls.start_date.hasError('dateOverlap')) {
      <div class="error-message">Start date must not overlap with another variation date range</div>
    }
  </form>

  <se-fe-button
    class="remove-price-variation-button"
    seFeDataEmphasis="low"
    [seFeDataSmall]="true"
    (click)="handleRemovePriceVariation()">
    Remove price variation
  </se-fe-button>
</se-fe-block>
